/* eslint-disable import/prefer-default-export */
export const validateSelectedProducts = (selectedProducts) => {
  const validItems = selectedProducts.filter(
    (el) => el._destroy !== true
  );

  if (!validItems.length) {
    return 'error1';
  }

  if (validItems.some((el) => !el.title)) {
    return 'error2';
  }

  if (validItems.some((el) => !el.quantity)) {
    return 'error3';
  }

  if (validItems.some((el) => Number(el.quantity) === 0)) {
    return 'error4';
  }

  if (validItems.some((el) => !el.unit_price || el.unit_price === '' || el.unit_price === null || el.unit_price === undefined)) {
    return 'error5';
  }

  return null;
};
